// Hide obsolete navigation without changing indexes used by existing show URLs.
export function isRetiredDiscussionSection(section) {
    if (!section) return false;
    const retired = ['discussion', 'discussionarea', 'discussionareas', 'chat', 'chatrooms', 'oldchat', 'liveqalist'];
    const type = (section.SectionTypeCode || '').toLowerCase();
    if (retired.includes(type)) return true;
    if (type === 'applink' && retired.includes((section.AppLinkTypeCode || '').toLowerCase())) return true;
    if (type === 'profile' && retired.includes((section.RelatedItemTypeCode || '').toLowerCase())) return true;
    return type === 'tractuslink' && /^tractus:\/\/(discussion|discussionarea|chat|oldchat)(?:\?|\/|#|$)/i.test((section.Content || '').trim());
}
